/*eslint-disable*/
import store from '@/store';
import { options } from 'less';
import { key } from 'localforage';
const tenantCode = store.getters.currentTenant.tenantCode;
// 表单配置信息
export const collapse = [
    {
        title: '退出报告信息',
        ref: 'qingshiForm',
        formName: 'qingshiInfo',
        col: 4,
        labelWidth: '100px',
        visible: true,
        formList: [
            {
                label: '申请编码',
                prop: 'renewalGroupCode',
                value: 'renewalGroupCode',
                type: 'custom',
                span: 23,
            },
            {
                label: '相关描述',
                prop: 'renewalRemark',
                value: 'renewalRemark',
                // type: 'custom',
                // span: 24,
                sourceType: 'input',
                inputType: 'textarea',
                type: 'input',
                span: 23,
                // maxlength: 1024,
                rows: 10,
                showWordLimit: true,
                rule: [{ required: true, message: '相关描述不能为空', trigger: 'change' }],
                disabled: false
            },
            {
                label: '附件',
                prop: 'relatedFiles',
                value: 'relatedFiles',
                type: 'custom',
                span: 23,
                rule: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (rule.required && !value.length) {
                                callback(new Error('相关附件不能为空'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
            },
            {
                label: '参考附件',
                prop: 'referenceFile',
                value: 'referenceFile',
                type: 'custom',
                dictKey: 'CONTRACT_RENEWAL_REGISTRATION',
                span: 24,
            },
            // {
            //     label: '客户类型',
            //     prop: 'customerType',
            //     value: 'customerType',
            //     sourceType: 'radio',
            //     inputType: 'radio',
            //     type: 'radio',
            //     options: [{
            //         label: 'TOP客户',
            //         value: "1"
            //     }, {
            //         label: '普通/CKA客户(其他)',
            //         value: "2"
            //     }, {
            //         label: '普通/CKA客户(CDC、VIM、城配送装 安得 全场景≥100万或干、支线≥200万)',
            //         value: "3"
            //     }],
            //     span: 24,
            // },
            {
                label: '',
                prop: 'registractionList',
                value: 'registractionList',
                type: 'custom',
                labelWidth: 0,
                span: 24,
            },
        ]
    },
    // {
    //     title: '相关附件',
    //     ref: 'relatedFileForm',
    //     formName: 'relatedFileInfo',
    //     col: 4,
    //     labelWidth: '80px',
    //     visible: true,
    //     formList: [
    //         {
    //             label: '附件',
    //             prop: 'relatedFiles',
    //             value: 'relatedFiles',
    //             type: 'custom',
    //             span: 23,
    //             rule: [
    //                 {
    //                     required: true,
    //                     validator: (rule, value, callback) => {
    //                         if (rule.required && !value.length) {
    //                             callback(new Error('相关附件不能为空'));
    //                         } else {
    //                             callback();
    //                         }
    //                     },
    //                     trigger: 'change'
    //                 }
    //             ],
    //         },
    //     ]
    // },
    // {
    //     title: '参考附件',
    //     ref: 'cankaoFileForm',
    //     formName: 'cankaoFileInfo',
    //     col: 4,
    //     labelWidth: '0px',
    //     visible: true,
    //     formList: [
    //         {
    //             label: '',
    //             prop: 'referenceFile',
    //             value: 'referenceFile',
    //             type: 'custom',
    //             dictKey: 'CRM_REFERENCE_ATTACHMENT',
    //             span: 24,
    //         },
    //     ]
    // },

];
